/* RESPONSIBLE TEAM: team-ml */
import Route from '@ember/routing/route';
import { ReactRoute } from 'embercom/lib/react-route';

export class WorkforceTeammatesRoute extends Route {
  reactEnabled() {
    return true;
  }
}

export default ReactRoute(WorkforceTeammatesRoute);
